<template>
  <div class="container">
    <BreadcrumbGroup :items="breadcrumbItems" />

    <HeadingOne>お勤め先情報の変更</HeadingOne>

    <ErrorsAlert :errors="errors"></ErrorsAlert>

    <WizardGroup class="_mb-md-60 _mb-sm-20">
      <MainWizard :active-index="1" type="useremploy"></MainWizard>
    </WizardGroup>

    <p>内容をご確認のうえ、よろしければ「変更する」を押してください。</p>

    <section>
      <HeadingTwo>お勤め先情報</HeadingTwo>

      <TableGroup>
        <TableBox>
          <TableBody>
            <TableRow>
              <TableHeader>
                職業
                <ChangeBadgeIcon
                  :diff-keys="diffKeys"
                  :key-list="['work_form']"
                ></ChangeBadgeIcon>
              </TableHeader>
              <TableData>
                {{ displayWorkForm(userData.work_form) }}
              </TableData>
            </TableRow>
            <TableRow>
              <TableHeader>
                業種
                <ChangeBadgeIcon
                  :diff-keys="diffKeys"
                  :key-list="['biz_type']"
                ></ChangeBadgeIcon>
              </TableHeader>
              <TableData>
                {{ displayBizType(userData.biz_type) }}
              </TableData>
            </TableRow>
            <TableRow>
              <TableHeader>
                職種
                <ChangeBadgeIcon
                  :diff-keys="diffKeys"
                  :key-list="['job_type']"
                ></ChangeBadgeIcon>
              </TableHeader>
              <TableData>
                {{ displayJobType(userData.job_type) }}
              </TableData>
            </TableRow>
            <TableRow>
              <TableHeader>
                お勤め先
                <ChangeBadgeIcon
                  :diff-keys="diffKeys"
                  :key-list="['office_nm']"
                ></ChangeBadgeIcon>
              </TableHeader>
              <TableData>
                {{ userData.office_nm }}
              </TableData>
            </TableRow>
            <TableRow>
              <TableHeader>
                お勤め先電話番号
                <ChangeBadgeIcon
                  :diff-keys="diffKeys"
                  :key-list="[
                    'office_phone_1',
                    'office_phone_2',
                    'office_phone_3',
                  ]"
                ></ChangeBadgeIcon>
              </TableHeader>
              <TableData>
                {{
                  displayOfficePhone(
                    userData.office_phone_1,
                    userData.office_phone_2,
                    userData.office_phone_3
                  )
                }}
              </TableData>
            </TableRow>
            <TableRow>
              <TableHeader>
                所属部署
                <ChangeBadgeIcon
                  :diff-keys="diffKeys"
                  :key-list="['office_depart']"
                ></ChangeBadgeIcon>
              </TableHeader>
              <TableData>
                {{ userData.office_depart }}
              </TableData>
            </TableRow>
            <TableRow>
              <TableHeader>
                入社年月
                <ChangeBadgeIcon
                  :diff-keys="diffKeys"
                  :key-list="['nsh_ngt']"
                ></ChangeBadgeIcon>
              </TableHeader>
              <TableData>
                {{ displayNshNgt(userData.nsh_ngt) }}
              </TableData>
            </TableRow>
            <TableRow>
              <TableHeader>
                社員数
                <ChangeBadgeIcon
                  :diff-keys="diffKeys"
                  :key-list="['staff_num']"
                ></ChangeBadgeIcon>
              </TableHeader>
              <TableData>
                {{ displayStaffNum(userData.staff_num) }}
              </TableData>
            </TableRow>
            <TableRow>
              <TableHeader>
                年収（税込）
                <ChangeBadgeIcon
                  :diff-keys="diffKeys"
                  :key-list="['gross_salary']"
                ></ChangeBadgeIcon>
              </TableHeader>
              <TableData>
                {{ displayGrossSalary(userData.gross_salary) }}
              </TableData>
            </TableRow>
          </TableBody>
        </TableBox>
      </TableGroup>

      <form novalidate @submit.prevent="submitWorkplace">
        <BtngroupDouble class="-margin-lg">
          <template #main>
            <BtnMain class="-main" @click.prevent="submitWorkplace">
              変更する
            </BtnMain>
          </template>
          <template #back>
            <BtnBack class="-back -sm" router-name="mb025"> 戻る </BtnBack>
          </template>
        </BtngroupDouble>
      </form>
    </section>
  </div>
  <!-- container -->
</template>

<script>
import { initCredentials } from "@/utils/Auth";
import {
  getUserDataForMemberLambdaInvoke,
  submitEditWorkplaceLambdaInvoke,
} from "@/utils/LambdaHelper";
import { setMeta } from "@/utils/Meta";
import { diffKeysGet } from "@/utils/ChangeIcon";
import { goToErrorPage, scrollTop } from "@/utils/Other";
import {
  displayWorkForm,
  displayBizType,
  displayJobType,
  displayOfficePhone,
  displayNshNgt,
  displayStaffNum,
  displayGrossSalary,
} from "@/utils/UserData";

import HeadingOne from "@/components/heading/HeadingOne";
import BtnMain from "@/components/button/BtnMain";
import BtnBack from "@/components/button/BtnBack";
import BtngroupDouble from "@/components/button/BtngroupDouble";
import HeadingTwo from "@/components/heading/HeadingTwo";
import TableBox from "@/components/tables/TableBox";
import TableBody from "@/components/tables/TableBody";
import TableRow from "@/components/tables/TableRow";
import TableHeader from "@/components/tables/TableHeader";
import TableData from "@/components/tables/TableData";
import MainWizard from "@/components/wizard/MainWizard";
import WizardGroup from "@/components/wizard/WizardGroup";
import TableGroup from "@/components/tables/TableGroup";
import ErrorsAlert from "@/components/alert/ErrorsAlert";
import ChangeBadgeIcon from "@/components/badges/ChangeBadgeIcon";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";

export default {
  name: "Mb028",
  components: {
    ChangeBadgeIcon,
    ErrorsAlert,
    TableGroup,
    WizardGroup,
    MainWizard,
    TableData,
    TableHeader,
    TableRow,
    TableBody,
    TableBox,
    HeadingTwo,
    BtngroupDouble,
    HeadingOne,
    BtnMain,
    BtnBack,
    BreadcrumbGroup,
  },
  setup() {
    setMeta({
      title: "お勤め先情報の変更｜お客さま情報の確認・変更",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,会員,会員サイト,お客さま情報",
    });

    return {
      displayWorkForm,
      displayBizType,
      displayJobType,
      displayOfficePhone,
      displayNshNgt,
      displayStaffNum,
      displayGrossSalary,
    };
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "mb001",
        },
        {
          text: "お客さま情報の確認・変更",
          routerName: "mb023",
        },
        {
          text: "お勤め先情報の変更",
          active: true,
        },
      ],
      input_gross_salary: "",
      isDisabled: false,
      errors: {},
      userData: {
        work_form: "",
        biz_type: "",
        job_type: "",
        office_nm: "",
        office_phone_1: "",
        office_phone_2: "",
        office_phone_3: "",
        office_depart: "",
        nsh_ngt: "",
        staff_num: "",
        gross_salary: "",
      },
      diffKeys: [],
    };
  },
  mounted() {
    try {
      getUserDataForMemberLambdaInvoke()
        .then((res) => {
          for (let key in res) {
            if (Object.prototype.hasOwnProperty.call(this.userData, key)) {
              this.userData[key] = res[key];
            }
          }
          this.input_gross_salary = this.userData.gross_salary / 10000;
        })
        .catch((error) => {
          goToErrorPage(error);
        });

      diffKeysGet()
        .then((res) => {
          this.diffKeys = res;
        })
        .catch((error) => {
          goToErrorPage(error);
        });
    } catch (e) {
      goToErrorPage(e);
    }
  },
  methods: {
    submitWorkplace() {
      try {
        if (this.isDisabled) {
          return;
        }
        this.isDisabled = true;
        this.errors = {};
        initCredentials()
          .then(() => {
            submitEditWorkplaceLambdaInvoke()
              .then((res) => {
                this.errors = res.errors || {};
                if (Object.keys(this.errors).length > 0) {
                  scrollTop();
                  this.isDisabled = false;
                } else {
                  this.$router.push({ name: "tem018" });
                }
              })
              .catch((error) => {
                goToErrorPage(error);
              });
          })
          .catch((error) => {
            goToErrorPage(error);
          });
      } catch (e) {
        goToErrorPage(e);
      }
    },
  },
};
</script>

<style scoped></style>
